import React from 'react'
import { PageTitle } from '../../layout/core'
import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import ProcessAutomation from '.'
import EditFormBuilder from '../../components/formBuilder/editForm'
import FormTable from '../../components/formBuilder/formSubmissionDetails'
import IBotListings from './iBotAssistant/IBotListings'
import PrefillRecipientsPage from './formBuilder/PrefillRecipientsPage'

const MainRoute: React.FC = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='process-automation/form-builder/share-form/:uuid/prefill-recipients'
          element={
            <>
              <PageTitle breadcrumbs={[]}>Recipient Forms</PageTitle>
              <section className='container-fluid px-4 pb-4'>
                <PrefillRecipientsPage />
              </section>
            </>
          }
        />
        <Route
          path='/process-automation/*'
          element={
            <>
              <ProcessAutomation />
            </>
          }
        />
        <Route path='edit-form/:uuid' element={<EditFormBuilder />} />
        <Route path='table/:uuid' element={<FormTable />} />
        <Route path='listIBots' element={<IBotListings />} />
        <Route index element={<Navigate to='/automation/process-automation' />} />
      </Route>
    </Routes>
  )
}

export default MainRoute
